<template>
    <div v-if="loading" class="loading-overlay">
      <div class="loading-container">
        <div class="spinner mt-3"></div>
        <div class="loading-text">Seohan</div>
      </div>
    </div>
    <div class="container-fluid py-3 mt-4 ">
        <div class="">
            <div class="d-flex align-center justify-space-between">
                <div>
                <p class="custom-text-h4 font-weight-bold text-black ma-2">Order Status View</p>
                <p class="font-weight-bold ml-5 mt-0 text-gray">
                    <v-icon icon="mdi-sort-reverse-variant" class="mr-2"></v-icon>Order Management > Order Status View
                </p>
                </div>

                <!-- 오른쪽 액션 버튼 영역 -->
                <!-- <div v-if="['P2002','P2004'].includes(username)">
                <v-btn
                    color="red-darken-1"
                    variant="tonal"
                    class="px-5 mr-5"
                    prepend-icon="mdi-file-pdf-box"
                    @click="openPdfDialog('A')"
                >
                    Print Plant 1 PO PDF
                </v-btn>
                <v-btn
                    color="red-darken-1"
                    variant="tonal"
                    class="px-5"
                    prepend-icon="mdi-file-pdf-box"
                    @click="openPdfDialog('B')"
                >
                    Print Plant 2,3 PO PDF
                </v-btn>
                </div> -->
            </div>
        </div>
      

      <v-row class="d-flex align-items-center mb-1">

        <v-col cols="2" class="pr-2 mr-15">
            <div class="split-box"  style="width: 33vh;">
                <div class="label-box">Part Number</div>
                <div class="select-box1">
                <v-text-field
                    v-model="search.partNumber"
                    placeholder="Enter Part Number"
                    dense
                    variant="plain"
                    hide-details
                />
                </div>
            </div>
        </v-col>
        <!-- Part Name 입력 필드 -->
        <v-col cols="2" class="pr-2 mr-15">
        <div class="split-box" style="width: 33vh;">
            <div class="label-box">Part Name</div>
            <div class="select-box2">
            <v-text-field
                v-model="search.partName"
                placeholder="Enter Part Name"
                dense
                variant="plain"
                hide-details
            />
            </div>
        </div>
        </v-col>


        <!-- Status 선택 필드 -->
        <v-col cols="2" class="pr-2 ">
        <v-menu offset-y>
            <template v-slot:activator="{ props }">
            <div class="split-box" v-bind="props">
                <div class="label-box">Status</div>
                <div class="select-box3">{{ search.status }}</div>
            </div>
            </template>
            <v-list>
            <v-list-item
                v-for="(item, index) in statusOptions"
                :key="index"
                @click="search.status = item"
            >
                <v-list-item-title>{{ item }}</v-list-item-title>
            </v-list-item>
            </v-list>
        </v-menu>
        </v-col>
        <v-col cols="4" class="d-flex align-items-center" style="padding-left: 3px">
            <!-- 라벨 박스만 따로 -->
            <div class="label-box date-label-box ml-5">Date</div>

            <!-- date picker 2개 나란히 -->
            <div class="d-flex align-center mb-2" style="gap: 0px;" >
                <vue-datepicker 
                v-model="date1"
                class="custom-datepicker"
                placeholder="Start Date"
                :text-input="textInputOptions"
                :enable-time-picker="false"
                :max="date2"
                :auto-apply="true"
                format="yyyy-MM-dd"
                />
                <span class="mx-3 mt-3" >~</span>
                <vue-datepicker 
                v-model="date2"
                class="custom-datepicker"
                placeholder="End Date"
                :text-input="textInputOptions"
                :enable-time-picker="false"
                :min="date1"
                :auto-apply="true"
                format="yyyy-MM-dd"
                />
            </div>
        </v-col>






        <!-- 검색 버튼 -->
        <v-col cols="1">
            <v-btn color="primary" class="search-btn " @click="getfilterData">
                <v-icon left>mdi-magnify</v-icon> Search
            </v-btn>
        </v-col>

        </v-row>
        <v-card class="custom-card-box custom-card" elevation="2" >
            <v-card-title class="custom-card-title">
                    PO Status                    
                </v-card-title>

        <div class="additional-content mt-3" style="padding-top: 3px; ">

            <v-data-table 
                :headers="headers" 
                :items="items" 
                :items-per-page = "-1"
                v-model:items-per-page="itemsPerPage"
                class="elevation-1 detail-table2" 
                height="30vh"
                density="compact"
                @click:row="openDetailPanel"
                hover
                fixed-header
                >
                <template v-slot:bottom> </template>

                <template #item="{ item }">
                    <tr @click="openDetailPanel($event, { item })" style="cursor: pointer;">
                    <td>{{ item.poNumber }}</td>
                    <td>{{ item.poDate }}</td>
                    <td>{{ item.poLastDay }}</td>

                    <td>{{ formatNumber(item.poQty) }}</td>
                    <td>{{ formatNumber(item.receivedQty) }}</td>
                    <td>{{ formatNumber(item.ScanItem) }}</td>

                    <td class="font-weight-bold">{{ formatNumber(item.remainQty) }}</td>
                    <td>{{ item.receivePercent }}</td> <!-- 콤마 적용 -->
                    <td  class="status-cell">
                        <v-chip
                        :color="item.status === 'Complete' ? 'green' : 'red'"
                        text-color="white"
                        x-small
                        class="status-chip"
                        >
                        {{ item.status }}
                        </v-chip>
                    </td>
                    </tr>
                </template>
                </v-data-table>
            </div>
            
        </v-card>

        <v-card class="custom-card-2 custom-card-box mb-2"  elevation="2" style="margin-bottom: 1px; padding-top: 0px;">
    <!-- <p class="po-details-title" style="margin-bottom: 0px;">
        PO Details <span v-if="selectedPoNumber">  {{ selectedPoNumber }}</span>
    </p> -->
        <v-card-title class="custom-card-title ">
            PO Details  <span v-if="selectedPoNumber">  {{ selectedPoNumber }}</span>
            
        </v-card-title>
    <!-- <v-divider style=" margin-bottom: 5px;"></v-divider> 여기에 추가 -->

    <div class="additional-content mt-3" style="padding-top: 3px; ">
        <!-- details가 존재하지 않거나 비어있으면 기본 메시지 표시 -->
        <p v-if="!details || details.length === 0">Click a PO number above to view details.</p>

        <!-- details에 데이터가 있으면 테이블을 렌더링 -->
        <v-data-table 
            v-else
            :headers="detailHeaders"
            :items="details"
            :items-per-page = "-1"
            class="elevation-1  detail-table"
            height="30vh"
            density="compact"
            fixed-header
        >
        <template v-slot:bottom> </template>
        <template v-slot:item="props">
            <tr>
                <td>{{ props.item.id }}</td>
                <td>{{ props.item.deliveryDate }}</td>
                <td>{{ props.item.productNumber }}</td>
                <td>{{ props.item.productName }}</td>
                <td>{{ props.item.location }}</td>

                <td>{{ formatNumber(props.item.orderQuantity) }}</td>
                <td>{{ formatNumber(props.item.receivedQuantity) }}</td>
                <td>{{ formatNumber(props.item.scanQuantity) }}</td>


                <td class="font-weight-bold">{{ formatNumber(props.item.remainingQuantity) }}</td>
                <td>{{ props.item.remainPercent }}</td>
                <td>
                    <v-chip
                        :color="props.item.status === 'Complete' ? 'green' : 'red'"
                        text-color="white"
                        x-small
                        class="status-chip"
                    >
                        {{ props.item.status }}
                    </v-chip>
                </td>
            </tr>
        </template>

        </v-data-table>
    </div>
</v-card>

        
    </div>

<!-- <v-dialog v-model="pdfDialog" max-width="760">
  <v-card>
    <v-card-title class="text-h6">Print PO PDF  {{ pdfPlantLabel }}</v-card-title>

    <v-card-text>
      <div class="d-flex align-center gap-3 mb-4" style="gap:12px">
        <v-select
          label="Year"
          :items="yearOptions"
          v-model="ymYear"
          class="mr-2"
          density="comfortable"
          style="max-width: 140px"
          variant="outlined"
        />
        <v-select
          label="Month"
          :items="monthOptions"
          item-title="label"
          item-value="value"
          v-model="ymMonth"
          density="comfortable"
          style="max-width: 140px"
          variant="outlined"
        />
        <v-spacer/>
        <v-btn color="primary" class="ml-2 mb-5" @click="fetchPdfRows">
          <v-icon class="mr-2">mdi-magnify</v-icon> Load
        </v-btn>
      </div>

      <v-data-table
        :headers="pdfHeaders"
        :items="pdfRows"
        :items-per-page="-1"
        class="elevation-1"
        density="compact"
        fixed-header
        height="45vh"
        >
        <template #[`item.PO_NO`]="{ item }">
            {{ item.__poDisplay }}
        </template>

        <template #[`item.date`]="{ item }">
            {{ item.__date }}
        </template>

        <template #[`item.actions`]="{ item }">
            <v-btn
            size="small"
            variant="text"
            @click="downloadPoPdf(item)"
            title="Download PDF"
            >

            </v-btn>
        </template>

        <template v-slot:bottom></template>
        </v-data-table>
    </v-card-text>

    <v-divider />

    <v-card-actions class="justify-end">
      <v-btn variant="text" @click="pdfDialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>   -->
    
</template>

<script>
import { mapState } from "vuex";
import axios from "axios"; // API 요청을 위해 axios 추가
import "@vuepic/vue-datepicker/dist/main.css";
import VueDatepicker from "@vuepic/vue-datepicker";

export default {
    components: {
            VueDatepicker,
            
        },
    data() {
        return {
            date1: this.getToday(), // 이번 달 1일
            date2: this.getToday(), // 오늘 날짜
            textInputOptions: {
                openMenu: true, // 클릭 시 자동으로 열림
                enterSubmit: true, // 엔터 입력 가능
            },
            search: {
                partNumber: "",
                partName: "",
                status: "ALL", // 기본값 ALL
            },
            statusOptions: ["ALL", "Not Complete", "Complete"], // Status 옵션
            headers: [
                { title: "PO Number", key: "poNumber", align: "center", sortable: true, class: "col-po-number" },
                { title: "PO Date", key: "poDate", align: "center", sortable: true, class: "col-po-date" },
                { title: "PO Last Day", key: "poLastDay", align: "center", sortable: true }, // 추가
                { title: "PO QTY", key: "poQty", align: "center", sortable: false, class: "col-po-qty" },
                { title: "Shipped QTY", key: "receivedQty", align: "center", sortable: false, class: "col-received-qty" },
                { title: "Received QTY", key: "scanQty", align: "center", sortable: false, class: "col-received-qty" },
                { title: "Remain QTY", key: "remainQty", align: "center", sortable: false, class: "col-remain-qty" },
                { title: "Receive Percent", key: "receivePercent", align: "center", sortable: false, class: "col-receive-percent" }, // 새 컬럼 추가
                { title: "Status", key: "status", align: "center", sortable: true, class: "col-status" },
            ],
            detailHeaders: [
                { title: "No.", key: "id", align: "center", sortable: false  },
                { title: "Date", key: "deliveryDate", align: "center" , sortable: false},
                { title: "Product No.", key: "productNumber", align: "center", sortable: false },
                { title: "Product Name", key: "productName", align: "center", sortable: false },
                { title: "Location", key: "location", align: "center", sortable: false }, // 추가!
                { title: "Order Quantity", key: "orderQuantity", align: "center" , sortable: false},
                { title: "Shipped Quantity", key: "receivedQuantity", align: "center", sortable: false },
                { title: "Received Quantity", key: "scanQuantity", align: "center", sortable: false },
                { title: "Remaining Quantity", key: "remainingQuantity", align: "center", sortable: false },
                { title: "Received Percent", key: "remainPercent", align: "center", sortable: false }, // 추가
                { title: "Status", key: "status", align: "center", sortable: true },
            ],
            items: [],
            details: [], // 초기값을 빈 배열로 설정
            selectedPoNumber: "", // 선택한 PO 번호 저장
            isHistoryModalVisible: false,  // 모달 상태
            partDetail: {},  // 선택된 부품 정보
            partHistory: [],  // 부품 히스토리
            loading: false,
            warehouseNameMap: {},

            pdfDialog: false,
            pdfPlantCode: 'A',    // 'A' | 'B'
            pdfPlantLabel: 'Plant 1 (A)',
            ymYear: null,
            ymMonth: null,
            // yearOptions: [],                 // ex) ['2024','2025','2026']
            monthOptions: [                  // 01~12
            { label: '01', value: '01' }, { label: '02', value: '02' },
            { label: '03', value: '03' }, { label: '04', value: '04' },
            { label: '05', value: '05' }, { label: '06', value: '06' },
            { label: '07', value: '07' }, { label: '08', value: '08' },
            { label: '09', value: '09' }, { label: '10', value: '10' },
            { label: '11', value: '11' }, { label: '12', value: '12' },
            ],
            pdfHeaders: [
            { title: 'PO Number', key: 'PO_NO', align: 'center' },
            { title: 'Date',      key: 'date',  align: 'center' },
            { title: 'Download',  key: 'actions', align: 'center' },
            ],
            pdfRows: [],
            
        };
    },
    computed: {
        // filteredItems() {
        //     return this.items.filter(item => 
        //         item.poNumber.toLowerCase().includes(this.search.toLowerCase())
        //     );
        // },
        ...mapState({
        username: (state) => state.username, // Vuex 상태에서 username 가져오기
        }),
        // selectedYM() {
        //     return this.ymYear && this.ymMonth ? `${this.ymYear}${this.ymMonth}` : null;
        // },
    },
    methods: {
        async fetchWarehouseNames() {
            try {
                const response = await axios.get("/api/getWarehouseName");
                const rows = response.data.data || [];

                this.warehouseNameMap = rows.reduce((map, row) => {
                    const code = String(row.ASDES || row.CODE || row.CODE_CD || row.value || "").trim();
                    const name = String(row.AREF1 || row.name || row.ASDES || "").trim();

                    if (code && name) {
                        map[code] = name;
                    }

                    return map;
                }, {});
            } catch (error) {
                console.error("getWarehouseName API 호출 오류:", error);
                this.warehouseNameMap = {};
            }
        },
        getWarehouseDisplayName(dockNo) {
            const code = String(dockNo || "").trim();
            return this.warehouseNameMap[code] || code;
        },
        // openPdfDialog(plantCode = 'A') {
        //     this.pdfPlantCode = plantCode === 'B' ? 'B' : 'A';
        //     this.pdfPlantLabel = this.pdfPlantCode === 'A' ? 'Plant 1' : 'Plant 2/3';
        //     const d = new Date(this.date1 || new Date());
        //     const y = d.getFullYear();
        //     const m = String(d.getMonth() + 1).padStart(2, '0');

        //     // 연도 옵션: 기본값 기준 과거 2년 ~ 미래 1년 (원하면 조정)
        //     const years = [];
        //     for (let yy = y-1 ; yy <= y ; yy++) years.push(String(yy));
        //     this.yearOptions = years;

        //     this.ymYear = String(y);
        //     this.ymMonth = m;

        //     this.pdfRows = [];
        //     this.pdfDialog = true;

        //     // 기본 로드
        //     this.fetchPdfRows();
        // },

        // formatFromTs(ts) {
        //     if (!ts) return '';
        //     const s = String(ts);
        //     if (s.length < 8) return '';
        //     const y = s.slice(0, 4), m = s.slice(4, 6), d = s.slice(6, 8);
        //     return `${y}/${m}/${d}`;
        // },

        // /** 서버 응답(rows.poGroups) -> 테이블용 평탄화 + 정렬 */
        // mapPoGroupsToRows(rowsObj) {
        //     const poGroups = Array.isArray(rowsObj?.poGroups) ? rowsObj.poGroups : [];
        //     const flat = [];

        //     for (const pg of poGroups) {
        //     const poNo = String(pg?.poNo ?? '').trim();
        //     const latestSub = Number(pg?.latestSubno) || 0;
        //     const groups = Array.isArray(pg?.groups) ? pg.groups : [];

        //     for (const g of groups) {
        //         const subno = Number(g?.subno) || 0;
        //         const list = Array.isArray(g?.rows) ? g.rows : [];
        //         if (!list.length) continue;

        //         // 같은 SUBNO 묶음 안에서 CREATED_TIME 가장 최신 1건 선택
        //         const latestRow = list.reduce((a, b) => {
        //         const A = String(a?.CREATED_TIME || '');
        //         const B = String(b?.CREATED_TIME || '');
        //         return B > A ? b : a;
        //         });

        //         flat.push({
        //         ...latestRow,
        //         __created: String(latestRow.CREATED_TIME || ''),
        //         __date: this.formatFromTs(latestRow.CREATED_TIME),
        //         __poDisplay: `${poNo} (${subno === latestSub ? 'Newest' : String(subno)})`,
        //         __poNo: poNo,
        //         __subno: subno,
        //         });
        //     }
        //     }

        //     // CREATED_TIME 내림차순 (가장 최신이 위)
        //     flat.sort((a, b) => {
        //     const A = a.__created || '';
        //     const B = b.__created || '';
        //     if (A.length !== B.length) return B.length - A.length;
        //     return B.localeCompare(A);
        //     });

        //     return flat;
        // },
        // /** 선택된 YM으로 리스트 조회 */
        // async fetchPdfRows() {
        //     if (!this.selectedYM) return;
        //     try {
        //     this.loading = true;

        //     const { data } = await axios.post('/api/getPDFInfo', {
        //         ym: this.selectedYM,
        //         username: this.username,
        //         plant: this.pdfPlantCode,
        //     });
        //     // 여기서 실제  구조에 맞게 매핑
        //     this.pdfRows = this.mapPoGroupsToRows(data?.rows);
        //     } catch (e) {
        //     console.error('fetchPdfRows error:', e?.message || e);
        //     this.pdfRows = [];
        //     } finally {
        //     this.loading = false;
        //     }
        // },
        // async downloadPoPdf(item) {
        //     try {
        //         this.loading = true;

        //         const payload = {
        //             po_no: item.__poNo,
        //             subno: item.__subno,
        //             ym: this.selectedYM,
        //             username: this.username,
        //             plant: this.pdfPlantCode
        //         };
        //         const resp = await axios.post(
        //             '/api/getPDFforPO',
        //             payload,
        //             { responseType: 'blob' } // 중요: 바이너리로 받기
        //         );

        //         const blob = new Blob([resp.data], { type: 'application/pdf' });
        //         const url = URL.createObjectURL(blob);
        //         const a = document.createElement('a');

        //         // 파일명 예시: 202510-023-(Newest).pdf 또는 202510-023-(4).pdf
        //         const subLabel = /Newest/.test(item.__poDisplay) ? 'Newest' : String(item.__subno);
        //         a.href = url;
        //         a.download = `${item.__poNo}-(${subLabel}).pdf`;
        //         a.click();
        //         URL.revokeObjectURL(url);
        //     } catch (e) {
        //         console.error('downloadPoPdf error:', e?.message || e);
        //     } finally {
        //         this.loading = false;
        //     }
        // },
        getFirstDayOfMonth() {
            const now = new Date();
            return new Date(now.getFullYear(), now.getMonth(), 1); // 이번 달 1일
        },
        getToday() {
            return new Date(); // 오늘 날짜
        },
        formatNumber(value) {
            if (!value) return "0"; // 값이 없으면 0 리턴
            return Number(value).toLocaleString(); // 천 단위 콤마 추가
        },
        async openDetailPanel(event, { item }) {
            this.loading = true;
            this.details = []; // 기존 데이터 초기화
            this.selectedPoNumber = item.poNumber; // 선택한 PO 번호 저장
            try {
                const response = await axios.get(`/api/orderStatusViewDetail`, {
                    params: { po_no: item.poNumber },
                });
                if (response.data.success) {
                    this.details = response.data.orders.map((order, index) => {
                        const orderQty = order.PO_QTY || 0;
                        const receivedQty = order.RP_QTY || 0;
                        const scanQuantity = order.ScanItem || 0;

                        const remainingQty = Math.max(orderQty - scanQuantity, 0); // 음수 방지
                        const remainPercent = orderQty > 0 ? ((scanQuantity / orderQty) * 100).toFixed(2) + "%" : "0%"; // Remain Percent 계산
                        const location = this.getWarehouseDisplayName(order.DOCK_NO);
                        this.loading = false;

                        return {
                            id: index + 1,
                            deliveryDate: this.formatDate(order.PO_YMD),
                            productNumber: order.ITEM_NO,
                            productName: order.ITEM_NM,
                            location,
                            orderQuantity: orderQty,
                            receivedQuantity: receivedQty,
                            scanQuantity: scanQuantity,
                            remainingQuantity: remainingQty,
                            remainPercent, // Remain Percent 추가
                            status: remainingQty <= 0 ? "Complete" : "Not Complete",
                        };
                    });
                } else {
                    this.details = [];
                    this.loading = false;

                }
            } catch (error) {
                this.loading = false;

                console.error("Error fetching order details:", error);
            }
        },

        openDetailModal(event, { item }) {
            this.partDetail = item.poNumber; // 선택한 poNumber 저장
            this.isHistoryModalVisible = true; // 모달 열기
        },
            
        addItem() {
        },
        async getOrderStatus() {
            try {
                this.loading = true; // API 호출 중 로딩 상태 활성화
                const response = await axios.get("/api/getOrderStatus", {
                    params: { username: this.username }, // 요청 시 username 전달
                });

                if (response.data.success) {
                    this.items = response.data.orders.map(order => {
                        const receivedQty = parseInt(order.RP_QTY, 10) || 0;
                        const poQty = parseInt(order.PO_QTY, 10) || 0;
                        const remainQty = Math.max(poQty - receivedQty, 0); // 음수면 0으로 처리
                        const status = remainQty <= 0 ? "Complete" : "Not Complete";
                        const receivePercent = poQty > 0 ? ((receivedQty / poQty) * 100).toFixed(2) + "%" : "0%"; // 퍼센트 계산

                        return {
                            poNumber: order.PO_NO,  // PO Number
                            poDate: this.formatDate(order.PO_YMD),  // PO Date
                            poQty: order.PO_QTY,  // PO QTY
                            receivedQty: order.RP_QTY,  // Received QTY
                            receivePercent,
                            remainQty: remainQty,  // Remain QTY (음수 방지)
                            status: status,  // Status (remain이 0이면 Complete)
                        };
                    });
                } else {
                    console.error("Failed to fetch order status");
                    this.items = []; // 실패 시 빈 배열
                }
            } catch (error) {
                console.error("Error fetching order status:", error);
            } finally {
                this.loading = false; // API 호출 완료 후 로딩 상태 해제
            }
        },
        async getfilterData() {
            this.details = []
            try {
                this.loading = true; // 로딩 상태 활성화

                if (!this.date1 || !this.date2) {
                    alert("⚠️ Both Start Date and End Date are required.");
                    this.loading = false;
                    return;
                }

                if (new Date(this.date2) < new Date(this.date1)) {
                    alert("⚠️ End Date cannot be earlier than Start Date.");
                    this.loading = false;
                    return;
                }
                // Status 값을 숫자로 변환 (ALL: 0, Complete: 1, Not Complete: 2)
                const statusMapping = {
                    "ALL": 0,
                    "Complete": 1,
                    "Not Complete": 2
                };
                const statusCode = statusMapping[this.search.status] || 0; // 기본값 0 (ALL)

                // API 요청
                const response = await axios.get("/api/getFilteredOrderStatus", {
                    params: {
                        part_number: this.search.partNumber,
                        part_name: this.search.partName,  // Part Name 전달
                        status: statusCode,  // 숫자로 변환한 Status 전달
                        username: this.username ,
                        date1: this.formatDateToYYYYMMDD(this.date1), // 변환된 date1
                        date2: this.formatDateToYYYYMMDD(this.date2), // 변환된 date2
                    }
                });
                if (response.data.success) {
                    this.items = response.data.orders.map(order => {
                        const poQty = parseInt(order.PO_QTY, 10) || 0;
                        const ScanItem = parseInt(order.ScanItem, 10) || 0;
                        const remainQty = Math.max(poQty - ScanItem, 0); // 음수면 0으로 처리
                        const status = remainQty <= 0 ? "Complete" : "Not Complete";
                        const receivePercent = poQty > 0 ? ((ScanItem / poQty) * 100).toFixed(2) + "%" : "0%"; // 퍼센트 계산

                        return {
                            poNumber: order.PO_NO,  // PO Number
                            poDate: this.formatDate(order.PO_YMD),  // PO Date
                            poLastDay: this.formatDate(order.REQ_YMD),
                            poQty: order.PO_QTY,  // PO QTY
                            receivedQty: order.RP_QTY,  // Received QTY
                            ScanItem: order.ScanItem,  // Received QTY
                            remainQty: remainQty,  // Remain QTY (음수 방지)
                            receivePercent,
                            status: status,  // Status (remain이 0이면 Complete)
                        };
                    });
                } else {
                    console.error("❌ Failed to fetch filtered order status");
                    this.items = []; // 실패 시 빈 배열
                }
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    console.warn("⚠ No matching orders found.");
                    this.items = []; // 404일 경우 테이블 클리어
                } else {
                    console.error("❌ Error fetching filtered order status:", error);
                }
            } finally {
                this.loading = false; // API 호출 완료 후 로딩 상태 해제
            }
        },
        formatDate(dateString) {
            if (!dateString) return "";
            const strDate = dateString.toString();
            return `${strDate.substring(0, 4)}-${strDate.substring(4, 6)}-${strDate.substring(6, 8)}`;
        },
        formatDateToYYYYMMDD(date) {
            if (!date) return ""; // 날짜가 없을 경우 빈 값 반환
            const d = new Date(date);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, "0"); // 두 자리 숫자로 변환
            const day = String(d.getDate()).padStart(2, "0"); // 두 자리 숫자로 변환
            return `${year}${month}${day}`; // YYYYMMDD 형식으로 반환
        },
    },

    async mounted() {
        await this.fetchWarehouseNames();
        this.getfilterData();
    }
}
</script>


<style scoped>
.modal-dialog {
  margin-top: 1000px; /* 원하는 값으로 조정 (기본값: auto) */
}

.custom-select {
    display: flex;
    align-items: center;
    border: 1px solid #d1d5db;
    background-color: white;
    border-radius: 4px;
    padding: 21px 20px;
    cursor: pointer;
    font-size: 16px;
    width: 250px;
    }
.custom-input {
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    padding-left: 12px;
    }

    .custom-value {
    flex: 1;
    text-align: left;
    color: #374151;
    padding-left: 20px;
    }

    /* Vuetify 기본 입력 필드 테두리, 그림자 제거 */
    .custom-input .v-input__control {
    border: none !important;
    min-height: 0 !important; /* 불필요한 높이 제거 */
    height: 100% !important;
    }

    /* 숫자 필드의 기본 스핀 버튼 완전 제거 */
    .custom-input input {
    -moz-appearance: none !important; /* Firefox */
    -webkit-appearance: none !important; /* Chrome, Safari */
    appearance: none !important;
    height: auto !important;
    min-height: unset !important;
    padding: 0 !important;
    text-align: left;
    }

    /* Vuetify에서 자동 생성되는 불필요한 UI 요소 제거 */
    .custom-input .v-input__control::before,
    .custom-input .v-input__control::after {
    display: none !important;
    }

    /* v-text-field 내부 입력 필드 정렬 */
    .custom-input .v-input__control {
    display: flex !important;
    align-items: center !important;
    }

    /* 불필요한 여백 제거 */
    .custom-input input {
    margin: 0 !important;
    padding: 0 !important;
    }
    
 .custom-label2 {
    color: #6b7280;
    font-weight: 500;
    margin-right: 12px;
    position: relative;
    padding-right: 12px;
    }

    .custom-label2::after {
    content: "";
    position: absolute;
    left: 10vh;
    top: 50%;
    transform: translateY(-50%);
    width: 2px;
    height: 170%;
    background-color:  #cccccc;
    }

    .custom-label3 {
    color: #6b7280;
    font-weight: 500;
    margin-right: 12px;
    position: relative;
    padding-right: 12px;
    }

    .custom-label3::after {
    content: "";
    position: absolute;
    left: 12vh;
    top: 50%;
    transform: translateY(-50%);
    width: 2px;
    height: 170%;
    background-color:  #cccccc;
    }
    .custom-label4 {
    color: #6b7280;
    font-weight: 500;
    margin-right: 12px;
    position: relative;
    padding-right: 12px;
    }
    .custom-label5 {
    color: #6b7280;
    font-weight: 500;
    margin-right: 12px;
    position: relative;
    padding-right: 12px;
    }


    .custom-label4::after {
    content: "";
    position: absolute;
    left: 8vh;
    top: 50%;
    transform: translateY(-50%);
    width: 2px;
    height: 180%;
    background-color: #cccccc;
    }

    .custom-label5::after {
    content: "";
    position: absolute;
    left: 6.2vh;
    top: 50%;
    transform: translateY(-50%);
    width: 2px;
    height: 170%;
    background-color:  #cccccc;
    }

    .container-input {
    display: flex;
    align-items: center;
    border: 1px solid #d1d5db;
    background-color: white;
    border-radius: 4px;
    padding: 12px 15px;
    font-size: 16px;
    width: 310px;
    height: 45px;
    }
    .container-input2 {
    display: flex;
    align-items: center;
    border: 1px solid #d1d5db;
    background-color: white;
    border-radius: 4px;
    padding: 12px 15px;
    font-size: 16px;
    width: 80px;
    height: 45px;
    }
    .container-input3 {
    display: flex;
    align-items: center;
    border: 1px solid #d1d5db;
    background-color: white;
    border-radius: 4px;
    padding: 12px 15px;
    font-size: 16px;
    width: 293px;
    height: 45px;
    }
.custom-width {
    max-width: 300px;
}

/* 배경색 적용 */
.custom-bg ::v-deep(.v-input__control) {
    background-color: rgb(255, 255, 255) !important;
}



.data-table-row:hover {
    background-color: #dfffdf;
    cursor: pointer;
}

:deep() .v-data-table thead th {
    font-weight: bold !important; /* 헤더 텍스트 굵게 */
    text-align: center; /* 중앙 정렬 */
}


.custom-text-h4 {
        font-size: 3rem !important;
        font-weight: 400;
        line-height: 2.5rem;
        text-transform: none !important;
        /* -webkit-text-stroke: 1px black; */
    }
    .custom-font{
    font-family: 'BebasNeue-Regular';
    font-size: 35px;
}
.section-divider {
  border: none;
  border-top: 1px solid #000000; /* 회색 선 */
  margin: 20px 0;
  margin-top: 0px;
}

:deep() .v-data-table thead th {
  font-weight: bold !important;
  text-align: center;
}

/* 줄무늬 */

:deep() .v-data-table tbody td:nth-child(6) {
  text-align: Center;
}
:deep() .v-data-table tbody td:nth-child(5) {
  text-align: Center;
}
:deep() .v-data-table tbody td:nth-child(4) {
  text-align: Center;
}
:deep() .v-data-table tbody td:nth-child(3) {
  text-align: Center;
}
:deep() .v-data-table tbody td:nth-child(2) {
  text-align: Center;
}
:deep() .v-data-table tbody td:nth-child(1) {
  text-align: Center;
}


.status-chip {
  height: 26px !important;         /* 칩 높이 */
  padding: 0 8px;       /* 좌우 패딩 */
  font-size: 18px !important;      /* 글자 크기 */
  border-radius: 2px;   /* 둥글기 */
  line-height: 20px;    /* 텍스트 중앙 정렬 */
  text-align: center;

}

:deep() .v-data-table thead th {
  font-size: 14px !important; /* 헤더 텍스트 크기 증가 */
  font-weight: bold !important;
}

:deep() .v-data-table tbody td {
  font-size: 15px !important; /* 본문 텍스트 크기 증가 */
  font-weight: 500;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.9);
  z-index: 9999;
}
.loading-container {
  display: flex;
  align-items: center;
  gap: 15px; /* 스피너와 텍스트 간격 */
}

/* 빙글빙글 도는 스피너 */
.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid rgba(0, 123, 255, 0.3);
  border-top: 5px solid #007bff;
  border-radius: 50%;
  animation: spin 2s linear infinite;
}

/* 스피너 애니메이션 */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/* 출렁이는 색상 변화 효과 */
.loading-text {
  font-size: 64px;
  font-weight: bold;
  text-transform: uppercase;
  background: linear-gradient(120deg, #ffffff, #007bff, #ffffff);
  background-size: 200% 200%;
  -webkit-background-clip: text;
  color: transparent;
  animation: waveColor 3s ease-in-out infinite;
}

/* 출렁이는 애니메이션 */
@keyframes waveColor {
  0% {
    background-position: 0% 70%;
  }
  50% {
    background-position: 100% 30%;
  }
  100% {
    background-position: 0% 70%;
  }
}

.custom-card {
  width: 100%; /* 너비 조절 */
  height: 37vh; /* 높이 조절 */
}
.custom-card-2 {
  width: 100%; /* 원하는 너비로 조정 가능 */
  height: 38vh; /* 높이 조정 가능 */
  margin: 20px auto; /* 가운데 정렬 */
  text-align: center;
  background-color: #ffffff; /* 배경색 추가 */
}

/* 추가적인 컨텐츠 스타일 */
.additional-content {
  padding: 20px;
  font-size: 16px;
  color: #333;
}

:deep(.detail-table .v-data-table-header th) {
    font-size: 10px !important; /* 헤더 글자 크기 줄이기 */
    font-weight: 500 !important;
    text-align: center;
    width: 100vh !important;
}
:deep(.status-cell) {
    text-align: center !important;
    justify-content: center;
    display: flex;
    align-items: center;
}

:deep(.detail-table thead th:nth-child(1)) { width: 10px !important; }
:deep(.detail-table thead th:nth-child(2)) { width: 120px !important; }
:deep(.detail-table thead th:nth-child(3)) { width: 120px !important; }
:deep(.detail-table thead th:nth-child(4)) { width: 150px !important; }
:deep(.detail-table thead th:nth-child(5)) { width: 120px !important; }
:deep(.detail-table thead th:nth-child(6)) { width: 120px !important; }
:deep(.detail-table thead th:nth-child(7)) { width: 120px !important; }
:deep(.detail-table thead th:nth-child(8)) { width: 120px !important; }
:deep(.detail-table thead th:nth-child(9)) { width: 120px !important; }
:deep(.detail-table thead th:nth-child(10)) { width: 120px !important; }
:deep(.detail-table thead th:nth-child(11)) { width: 120px !important; }



:deep(.detail-table2 thead th:nth-child(1)) { width: 120px !important; }
:deep(.detail-table2 thead th:nth-child(2)) { width: 120px !important; }
:deep(.detail-table2 thead th:nth-child(3)) { width: 120px !important; }
:deep(.detail-table2 thead th:nth-child(4)) { width: 120px !important; }
:deep(.detail-table2 thead th:nth-child(5)) { width: 120px !important;  }
:deep(.detail-table2 thead th:nth-child(6)) { width: 120px !important;  }
:deep(.detail-table2 thead th:nth-child(7)) { width: 120px !important;  }
:deep(.detail-table2 thead th:nth-child(8)) { width: 120px !important;  }
:deep(.detail-table2 thead th:nth-child(9)) { width: 120px !important;  }





/* detail-table 숫자 컬럼 오른쪽 정렬 */
:deep(.detail-table tbody td:nth-child(6)),
:deep(.detail-table tbody td:nth-child(7)),
:deep(.detail-table tbody td:nth-child(8)),
:deep(.detail-table tbody td:nth-child(9)) {
    text-align: right !important;
}


:deep(.detail-table2 tbody td:nth-child(8)),

:deep(.detail-table2 tbody td:nth-child(7)),
:deep(.detail-table2 tbody td:nth-child(4)),
:deep(.detail-table2 tbody td:nth-child(5)),
:deep(.detail-table2 tbody td:nth-child(6)) {
    text-align: right !important;
}
/* 메인 테이블 숫자 컬럼 오른쪽 정렬 */
.custom-datepicker {
    width: 150px; /* 원하는 너비 조정 */
    height: 35px;
    border-radius: 5px;
    text-align: center;
    font-size: 14px;
    top: -1px
}

/* Datepicker 드롭다운 크기 조절 */
:deep(.dp__menu_inner) {
    width: 260px !important; /* 너비 조정 */
    font-size: 14px !important; /* 폰트 크기 조정 */
}
:deep(.dp__main) {
    background-color: transparent !important;
    box-shadow: none !important; /* 그림자도 제거 */
    border: none !important; /* 테두리 제거 */
}
:deep(.dp_input){
    height: 500px !important;
    padding-bottom: 10px !important;
}
@font-face {
    font-family: 'HyundaiSans2';
    src: url('../../assets/fonts/HyundaiSansHeadKRMedium.woff2') format('woff2');
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'HyundaiSans';
    src: url('../../assets/fonts/HYUNDAISANSHEADKRREGULAR.TTF') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('../../assets/fonts/HYUNDAISANSHEADKRBOLD.TTF') format('truetype');
    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('../../assets/fonts/HYUNDAISANSHEADKRMEDIUM.TTF') format('truetype');
    font-weight: 500;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('../../assets/fonts/HYUNDAISANSHEADKRLIGHT.TTF') format('truetype');
    font-weight: 300;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSansText';
    src: url('../../assets/fonts/HYUNDAISANSTEXTKRREGULAR.TTF') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSansText';
    src: url('../../assets/fonts/HYUNDAISANSTEXTKRMEDIUM.TTF') format('truetype');
    font-weight: 500;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSansText';
    src: url('../../assets/fonts/HYUNDAISANSTEXTKRBOLD.TTF') format('truetype');
    font-weight: bold;
    font-style: normal;
}
@font-face {
    font-family: 'hyundai2';
    src: url('../../assets/fonts/hundai-M.ttf') format('truetype');
    font-weight: bold;
    font-style: normal;
}
@font-face {
    font-family: 'hyundai';
    src: url('../../assets/fonts/hyundai-L.ttf') format('truetype');
    font-style: normal;
}
/* 전체 애플리케이션의 기본 폰트로 적용 */
* {
    font-family: 'hyundai' !important;
}


:deep(.dp__input) {
    width: 150px !important;
    height: 45px !important;
    border-radius: 5px !important;
    padding: 5px 2px !important;
    text-align: center !important;
    font-size: 14px !important;
    border-top-left-radius: 0% !important;
        border-bottom-left-radius: 0% !important;
        border-top-right-radius: 4px !important;
        border-bottom-right-radius: 4px !important;
}
.po-details-title {
    font-size: 22px;
    font-weight: bold;
    color: #333; /* 진한 색상 */
    text-align: center;
    margin-bottom: 10px;

}

:deep() .v-data-table thead th {
  border-right: 2px solid #ccc !important;
  border-bottom: 1.5px solid #ccc !important;
  border-top: 1.5px solid #ccc !important;
  border-left: 1.5px solid #ccc !important;
  background-color: #fff !important;
}

:deep() .v-data-table tbody td {
  border-right: 1px solid #e0e0e0 !important;
  border-bottom: 1px solid #e0e0e0 !important;
}

:deep(.v-data-table.detail-table2 thead th) {
  border: 1.5px solid #ccc !important;
  background-color: #e3f2fd !important;
  color: #000 !important;
}

:deep(.v-data-table.detail-table2 tbody td) {
  border: 1px solid #e0e0e0 !important;
}

:deep() .v-table .v-table__wrapper>table>tbody>tr>td {
    border: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
}


.split-box {
  display: flex;
  width: 100%;
  height: 45px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  overflow: hidden;
  font-size: 16px;
  background-color: white;
}

.label-box {
  background-color: #f4f4f4;
  
  padding: 0 16px;
  display: flex;
  align-items: center;
  font-weight: bold;
  color: #374151;
  white-space: nowrap;
  border-right: 1px solid #d1d5db;
}

.select-box1 {
  flex: 1;
  padding-top: 4px;
  padding-left: 16px;
  display: flex;
  align-items: center;
  color: #374151;
  cursor: pointer;
  max-width: 20vh;
}
:deep(.v-field__input) {
  padding-top: 4px !important; /* Vuetify 기본 padding-top 제거 */

}

.select-box2 {
  flex: 1;
  padding-left: 16px;
  display: flex;
  align-items: center;
  color: #374151;
  cursor: pointer;
}

.select-box3 {
  flex: 1;
  padding-left: 16px;
  display: flex;
  align-items: center;
  color: #374151;
  cursor: pointer;
}

.select-box4 {
  flex: 1;
  padding-left: 16px;
  display: flex;
  align-items: center;
  color: #374151;
  cursor: pointer;
}
.date-label-box {
  background-color: #f4f4f4;
  height: 45px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  font-weight: bold;
  color: #374151;
  white-space: nowrap;
  border: 1px solid #d1d5db;
  border-radius: 4px 0 0 4px;
  border-right: none;
}
.custom-card-title {
  background-color: #6ea6d9; /* 파란 배경 */
  align-items: center;
  color: white;
  font-weight: bold;
  font-size: 20px;
  padding: 5px 20px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  text-align: left;

}
.custom-card-box {
  border-radius: 4px;
  overflow: hidden; /* 둥근 모서리 유지 */
}
.container-fluid {
  height : 95%;
  overflow-y: auto;
}
:deep() .v-data-table thead th {
  background-color: #e3f2fd !important; /* 연한 파란색 */
  color: #000000 !important; /* 헤더 글씨 색 (딥 블루 계열) */
  font-weight: bold !important;
  text-align: center;
}
:deep() .v-data-table tbody tr:nth-child(even) {
  background-color: #f5f5f5 !important; /* 짝수 행 연한 회색 */
}

:deep() .v-data-table tbody tr:nth-child(odd) {
  background-color: white !important; /* 홀수 행 흰색 */
}



</style>
